import React from 'react';
export const SpecialOfferSection = () => {
  return <section className="py-12 border-t border-gray-200" data-id="element-42">
      <div className="mb-8" data-id="element-43">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3kNpHHRQ7LDu2YsR62XQt7/2_%285%29.png" alt="Zenora Smart Ring - Back in Stock 40% OFF" className="w-full h-auto rounded-lg shadow-lg mb-8" data-id="element-44" />
      </div>
      <div className="bg-blue-50 border-2 border-blue-500 p-6 mb-8" data-id="element-45">
        <div data-id="element-46">
          <p className="text-gray-700 mb-4" data-id="element-47">
            <span className="font-bold" data-id="element-48">PLEASE NOTE:</span> To celebrate being
            back in stock, Zenora is offering a special online-exclusive deal
            for a limited time.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-49">
            All new customers will receive{' '}
            <span className="font-bold" data-id="element-50">40% Off + Free Worldwide Shipping</span>{' '}
            on their order.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-51">
            This deal can end at any moment due to high demand and the limited
            nature of each production run—so we recommend securing your discount
            while stock is available.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-52">
            Your purchase is also backed by a 30-day, no-questions-asked
            guarantee. If you don't absolutely love your Zenora Smart Ring,
            simply return it for a full refund.
          </p>
          <p className="text-gray-700 font-medium" data-id="element-53">
            Zenora continues to sell out because of its trusted,
            subscription-free health insights. We strongly recommend checking
            availability now to see if your size is in stock.
          </p>
        </div>
      </div>
      <div className="text-center" data-id="element-54">
        <a href="https://zenora.shop/products/zenora-smart-ring" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#f4d17a] text-black font-bold py-4 px-8 w-full md:w-auto md:min-w-[300px] mb-4 rounded-md text-xl no-underline hover:bg-[#f0c85c] transition-colors" data-id="element-55">
          Check Availability
        </a>
        <p className="text-gray-600" data-id="element-56">
          Click the link above to see if the 40% Off + Free Shipping deal is
          still available today.
        </p>
      </div>
    </section>;
};